import UIComponent from '../../common/UIComponent';
import { clearAllNode } from '../../common/Utils';
import log from 'loglevel';
import './index.css';

export default class DefinitionBtn extends UIComponent {
  constructor(UIMainRight, interfaces, elementId) {
    super();
    this.UIMainRight = UIMainRight;
    this.interfaces = interfaces;
    this.elementId = elementId;
    this.Lang = interfaces.language;
    this.definitionMap = new Map();
    this.init();
    // this.definitionListPopup.style.display = "none";
    this.definitionComponent.style.display = 'none';
    window.addEventListener('orientationchange', () => {
      this.definitionComponent.style.display = 'block';
      if (window.orientation == 180 || window.orientation == 0) {
        // 竖屏
        this.definitionComponent.style.display = 'none';
      }
      if (window.orientation == 90 || window.orientation == -90) {
        // 横屏
        this.definitionComponent.style.display = 'block';
      }
    });

    this.definitionListPopup.addEventListener(
      'click',
      e => {
        e.stopPropagation();
        e.preventDefault();
      },
      false
    );

    this.interfaces.on(VhallPlayer.DEFINITION_CHANGE, res => {
      let def;
      switch (res.newValue.def) {
        case 'a':
          def = this.Lang.definition.audio;
          break;
        case 'same':
          def = this.Lang.definition.same;
          break;
        default:
          def = res.newValue.def;
          break;
      }

      this.definitionBtn.innerText = def;

      for (let i = 0; i < document.querySelectorAll('.definition-list-box li').length; i++) {
        const value = document.querySelectorAll('.definition-list-box li')[i];
        value.removeAttribute('class');
        if (value.innerText === def) {
          value.classList.add('active');
        }
      }
    });

    this.interfaces.on(VhallPlayer.CHANGE_SCHEDULER_DATA, res => {
      // this.definitionListBox.innerHTML = "";
      clearAllNode(this.definitionListBox);
      let currentDefList = this.interfaces.getQualitys();
      for (let i = 0; i < currentDefList.length; i++) {
        const value = currentDefList[i];
        this.definitionItem = document.createElement('li');

        value.def === this.interfaces.getCurrentQuality().def ? this.definitionItem.classList.add('active') : undefined;

        switch (value.def) {
          case 'a':
            this.definitionItem.innerText = this.Lang.definition.audio;
            this.definitionMap.set(this.Lang.definition.audio, value);
            break;
          case 'same':
            this.definitionItem.innerText = this.Lang.definition.same;
            this.definitionMap.set(this.Lang.definition.same, value);
            break;
          default:
            this.definitionItem.innerText = value.def;
            this.definitionMap.set(value.def, value);
            break;
        }
        this.definitionItem.onclick = this.handleItemClick.bind(this);

        // 清晰度列表追加
        this.definitionListBox.appendChild(this.definitionItem);
      }
    });
    //
    this.interfaces.on(VhallPlayer.LIVESUBTITLE_OPENED, res => {
      // this.definitionListBox.innerHTML = "";
      clearAllNode(this.definitionListBox);
      let currentDefList = this.interfaces.getQualitys();
      for (let i = 0; i < currentDefList.length; i++) {
        const value = currentDefList[i];
        this.definitionItem = document.createElement('li');

        value.def === this.interfaces.getCurrentQuality().def ? this.definitionItem.classList.add('active') : undefined;

        switch (value.def) {
          case 'a':
            this.definitionItem.innerText = this.Lang.definition.audio;
            this.definitionMap.set(this.Lang.definition.audio, value);
            break;
          case 'same':
            this.definitionItem.innerText = this.Lang.definition.same;
            this.definitionMap.set(this.Lang.definition.same, value);
            break;
          default:
            this.definitionItem.innerText = value.def;
            this.definitionMap.set(value.def, value);
            break;
        }
        this.definitionItem.onclick = this.handleItemClick.bind(this);

        // 清晰度列表追加
        this.definitionListBox.appendChild(this.definitionItem);
      }
    });

    this.interfaces.on(VhallPlayer.LIVESUBTITLE_CLOSED, res => {
      // this.definitionListBox.innerHTML = "";
      clearAllNode(this.definitionListBox);
      let currentDefList = this.interfaces.getQualitys();
      for (let i = 0; i < currentDefList.length; i++) {
        const value = currentDefList[i];
        this.definitionItem = document.createElement('li');

        value.def === this.interfaces.getCurrentQuality().def ? this.definitionItem.classList.add('active') : undefined;

        switch (value.def) {
          case 'a':
            this.definitionItem.innerText = this.Lang.definition.audio;
            this.definitionMap.set(this.Lang.definition.audio, value);
            break;
          case 'same':
            this.definitionItem.innerText = this.Lang.definition.same;
            this.definitionMap.set(this.Lang.definition.same, value);
            break;
          default:
            this.definitionItem.innerText = value.def;
            this.definitionMap.set(value.def, value);
            break;
        }
        this.definitionItem.onclick = this.handleItemClick.bind(this);

        // 清晰度列表追加
        this.definitionListBox.appendChild(this.definitionItem);
      }
    });
  }

  init() {
    // 清晰度组件容器
    this.definitionComponent = document.createElement('div');
    this.definitionComponent.setAttribute('class', 'vhallPlayer-definition-component');

    // 清晰度按钮
    this.definitionBtn = document.createElement('span');
    this.definitionBtn.setAttribute('class', 'vhallPlayer-definitionBtn');
    this.definitionBtn.onclick = this.handleBtnClick.bind(this);
    switch (this.interfaces.getCurrentQuality().def) {
      case 'a':
        this.definitionBtn.innerText = this.Lang.definition.audio;
        break;
      case 'same':
        this.definitionBtn.innerText = this.Lang.definition.same;
        break;
      default:
        this.definitionBtn.innerText = this.interfaces.getCurrentQuality().def || '';
        break;
    }

    // 清晰度弹窗容器
    this.definitionListPopup = document.createElement('div');
    this.definitionListPopup.setAttribute('class', 'h5definition-popup');

    this.videoNodeContainer = document.querySelector(this.elementId);
    // videoNode.onclick  = this.handleComponentMouseLeave.bind(this);
    this.videoNodeContainer.addEventListener('click', () => {
      // this.handleComponentMouseLeave.bind(this);
      this.definitionBtn.setAttribute('class', 'vhallPlayer-definitionBtn');
      this.definitionListPopup.style.display = 'none';
    });
    // this.definitionListTitle = document.createElement('div');
    // this.definitionListTitle.setAttribute("class", "definition-title");
    // this.definitionListTitle.innerText = this.Lang.definition.title;

    // 清晰度列表
    this.definitionListBox = document.createElement('ul');
    this.definitionListBox.setAttribute('class', 'definition-list-box');

    // 列表中追加标题
    // this.definitionListBox.appendChild(this.definitionListTitle);

    for (let i = 0; i < this.interfaces.getQualitys().length; i++) {
      const value = this.interfaces.getQualitys()[i];
      this.definitionItem = document.createElement('li');

      value.def === this.interfaces.getCurrentQuality().def ? this.definitionItem.classList.add('active') : undefined;

      switch (value.def) {
        case 'a':
          this.definitionItem.innerText = this.Lang.definition.audio;
          this.definitionMap.set(this.Lang.definition.audio, value);
          break;
        case 'same':
          this.definitionItem.innerText = this.Lang.definition.same;
          this.definitionMap.set(this.Lang.definition.same, value);
          break;
        default:
          this.definitionItem.innerText = value.def;
          this.definitionMap.set(value.def, value);
          break;
      }
      this.definitionItem.onclick = this.handleItemClick.bind(this);

      // 清晰度列表追加
      this.definitionListBox.appendChild(this.definitionItem);
    }

    // 弹窗追加列表
    this.definitionListPopup.appendChild(this.definitionListBox);

    // 组件容器追加按钮
    this.definitionBtn.innerText && this.definitionComponent.appendChild(this.definitionBtn);

    // 组件容器追加弹窗
    this.insertElement(this.UIMainRight, this.definitionComponent);
    this.appendChild(this.elementId, this.definitionListPopup);
  }

  handleComponentMouseLeave() {
    this.definitionBtn.setAttribute('class', 'vhallPlayer-definitionBtn');
    this.definitionListPopup.style.display = 'none';
    // this.definitionListPopup.style.opacity = "0";
  }

  handleBtnClick(e) {
    this.definitionBtn.setAttribute('class', 'vhallPlayer-definitionBtn active');
    this.h5vhallPlayer_brarage_popup_Landscape = this.videoNodeContainer.querySelector(
      '.h5vhallPlayer-brarage-popup-Landscape'
    );
    if (
      this.h5vhallPlayer_brarage_popup_Landscape &&
      this.h5vhallPlayer_brarage_popup_Landscape.style.display === 'block'
    ) {
      this.h5vhallPlayer_brarage_popup_Landscape.style.display = 'none';
    }
    this.definitionListPopup.style.display = 'block';
    // this.definitionListPopup.style.opacity = "1";
    e.stopPropagation();
  }

  handleItemClick(event) {
    for (let i = 0; i < document.querySelectorAll('.definition-list-box li').length; i++) {
      const value = document.querySelectorAll('.definition-list-box li')[i];
      value.removeAttribute('class');
    }
    event.target.classList.add('active');
    const value = event.target.innerText;
    this.definitionBtn.innerText = value;
    this.definitionBtn.setAttribute('class', 'vhallPlayer-definitionBtn');
    this.definitionListPopup.style.display = 'none';
    // this.definitionListPopup.style.opacity = "0";
    this.interfaces
      .setQuality(this.definitionMap.get(value))
      .then(() => {
        log.info('切换清晰度成功');
      })
      .catch(err => {
        log.error('切换清晰度失败：' + err);
      });
  }
}
